import { NOTHING_ON_FILE, insuranceHeadline } from 'components/Appointment/ConfirmAppointmentModal/helper';
import { capitalize } from 'lodash';
import { MEDICAL_GROUPS } from 'components/Profile/MedicalHistory/helper';
import { SUMMARY_BUILDERS, checkedNames } from 'components/Profile/View/helper';
import { getProfileCompletion, getStepById, isAllComplete } from 'pages/Profile/helper';
import { formatPhone } from 'utils/helpers';

export const getUpcomingAppointments = (dashboard) =>
  dashboard?.attributes?.upcoming_appointments?.data ?? [];

export const findAppointment = (appointments, encodedId) =>
  appointments.find(({ attributes }) => attributes.encoded_id === encodedId);

export const arePatientFormsComplete = (profile) =>
  isAllComplete(getProfileCompletion(profile?.attributes));

export const getProfileSections = (profile) => ({
  personal: profile?.attributes?.personal_information?.data?.attributes,
  insurance: profile?.attributes?.insurance_intake?.data?.attributes,
  medical: profile?.attributes?.medical_history?.data?.attributes,
  practice: profile?.attributes?.practice?.data?.attributes,
});

const PENDING_MESSAGES = {
  personal: 'Add your contact details so we can reach you',
  insurance: 'Add your insurance so we can verify your coverage',
  medical: 'Tell us about any allergies, conditions or medications',
};

const emptyMessage = (stepId, attributes, rows, completed) =>
  (attributes && SUMMARY_BUILDERS[stepId](attributes)?.empty?.title) ||
  (rows.length ? null : completed ? NOTHING_ON_FILE : PENDING_MESSAGES[stepId]);

export const getProfileCards = ({ personal, insurance, medical }, completion = {}) =>
  [
    {
      id: 'personal',
      title: 'Personal information',
      attributes: personal,
      rows: [
        { label: 'Mobile', value: personal?.mobile_phone ? formatPhone(personal.mobile_phone) : '' },
        { label: 'Email', value: personal?.email },
      ],
    },
    {
      id: 'insurance',
      title: 'Insurance',
      attributes: insurance,
      carrier: insurance?.insurance_company?.data?.attributes,
      rows: [
        { label: 'Plan', value: insuranceHeadline(insurance) },
        { label: 'Member ID', value: insurance?.member_id },
      ],
    },
    {
      id: 'medical',
      title: 'Medical records',
      attributes: medical,
      rows: [
        ...MEDICAL_GROUPS.map(({ name }) => ({
          label: capitalize(name),
          value: checkedNames(medical?.[name]).join(', '),
        })),
        { label: 'Notes', value: medical?.medical_notes },
      ],
    },
  ].map(({ attributes, ...card }) => {
    const { icon, iconBg, iconColor } = getStepById(card.id);
    const rows = card.rows.filter(({ value }) => value && value !== NOTHING_ON_FILE);
    const completed = Boolean(completion[card.id]);
    const empty = emptyMessage(card.id, attributes, rows, completed);

    return {
      ...card,
      rows,
      empty,
      completed,
      carrier: empty ? null : card.carrier,
      icon,
      iconBg,
      iconColor,
    };
  });

export const LABEL = 'text-[10px] font-semibold uppercase tracking-widest text-secondary-400';
export const ROW = 'flex items-center justify-between gap-2 sm:gap-3';
export const ROW_TITLE = 'flex min-w-0 items-center gap-2 text-[13px] font-semibold text-secondary-900';
export const BADGE = 'text-[10px] px-2 py-0.5';
export const CARD = 'bg-white border border-gray-200 rounded-2xl';
export const CHIP = 'rounded-full px-3.5 py-1.5 text-xs font-semibold transition-colors';
export const SECTION = 'bg-secondary-50 rounded-2xl p-3.5';
